import React from "react";
import SelectFormGroup from "../SelectFormGroup/SelectFormGroup";
const options = [
    "",
    "AA",
    "AE",
    "AK",
    "AL",
    "AP",
    "AR",
    "AS",
    "AZ",
    "CA",
    "CO",
    "CT",
    "DC",
    "DE",
    "FL",
    "FM",
    "GA",
    "GU",
    "HI",
    "IA",
    "ID",
    "IL",
    "IN",
    "KS",
    "KY",
    "LA",
    "MA",
    "MD",
    "ME",
    "MH",
    "MI",
    "MN",
    "MO",
    "MP",
    "MS",
    "MT",
    "NC",
    "ND",
    "NE",
    "NH",
    "NJ",
    "NM",
    "NV",
    "NY",
    "OH",
    "OK",
    "OR",
    "PA",
    "PR",
    "PW",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VA",
    "VI",
    "VT",
    "WA",
    "WI",
    "WV",
    "WY"
].map(value => ({
    value,
    label: value
}));
const StateFormGroup = (props) => (<SelectFormGroup {...props} options={options}/>);
export default StateFormGroup;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/StateFormGroup/StateFormGroup.tsx